import { BroadcastMessage } from "components/BroadcastMessage/BroadcastMessage";
import { Button } from "components/DesignSystem/Button/Button";
import { Checkbox } from "components/DesignSystem/Checkbox/Checkbox";
import Modal from "components/DesignSystem/Modal/Modal";
import { Label, TextInput } from "components/DesignSystem/TextInput/TextInput";
import { FormikForm } from "components/FormikForm/FormikForm";
import { Field, FieldProps } from "formik";
import { useModal } from "hooks/useModal";
import { ModalProps } from "types/utils/modal";
import { object, string } from "yup";
import Radio from "components/DesignSystem/RadioGroup/RadioGroup";
import { useAuth } from "hooks/useAuth";
import { CheckboxField } from "components/DesignSystem/Checkbox/CheckboxField";

export type BroadcastFormValues = {
  title: string;
  broadcastViaChat: boolean;
  broadcastViaEmail: boolean;
  broadcastViaWhatsapp: boolean;
  broadcastViaIvrCall: boolean;
  broadcastVia: "TEAM" | "user";
};

export const UnifiedBroadcast = ({ isOpen, close }: ModalProps) => {
  const broadcastCsv = useModal();
  const { name } = useAuth();

  const handleClose = () => {
    broadcastCsv.close();
    close();
  };

  return (
    <>
      <Modal.Root open={isOpen} onOpenChange={close}>
        <Modal.Content size="small" asChild>
          <FormikForm<BroadcastFormValues>
            initialValues={{
              title: "",
              broadcastViaChat: false,
              broadcastViaEmail: false,
              broadcastViaWhatsapp: false,
              broadcastViaIvrCall: false,
              broadcastVia: "TEAM",
            }}
            onSubmit={() => {}}
            validationSchema={object({
              title: string().required(""),
            })}
          >
            {({ isValid, values, setFieldValue }) => {
              const {
                broadcastViaChat,
                broadcastViaEmail,
                broadcastViaIvrCall,
                broadcastViaWhatsapp,
              } = values;

              const broadcastMediumSelected =
                broadcastViaChat ||
                broadcastViaEmail ||
                broadcastViaIvrCall ||
                broadcastViaWhatsapp;

              const showBroadcastVia =
                broadcastViaChat || broadcastViaEmail || broadcastViaWhatsapp;

              return (
                <>
                  <Modal.Header>
                    <Modal.Title>Broadcast Message</Modal.Title>
                    <Modal.Close />
                  </Modal.Header>
                  <Modal.Body className="t-space-y-6">
                    <TextInput
                      name="title"
                      label="Title of broadcast"
                      placeholder="Enter title"
                      required
                    />
                    <div>
                      <Label required>Select broadcast medium</Label>
                      <div className="t-grid t-grid-cols-2 t-gap-x-10 t-gap-y-3">
                        <CheckboxField
                          name="broadcastViaChat"
                          checkboxProps={{
                            label: "Chat",
                          }}
                        />
                        <CheckboxField
                          name="broadcastViaEmail"
                          checkboxProps={{ label: "Email" }}
                        />
                        <CheckboxField
                          name="broadcastViaWhatsapp"
                          checkboxProps={{ label: "Whatsapp" }}
                        />
                        <CheckboxField
                          name="broadcastViaIvrCall"
                          checkboxProps={{ label: "IVR Call" }}
                        />
                      </div>
                    </div>
                    {showBroadcastVia && (
                      <div className="t-flex t-flex-col t-gap-3">
                        <Label
                          required
                          className="t-w-fit !t-pb-0 !t-text-body-sm"
                        >
                          Broadcast on Chat via{" "}
                        </Label>
                        <Radio.Root
                          onValueChange={(value) =>
                            setFieldValue(
                              "broadcastVia",
                              value as "user" | "TEAM"
                            )
                          }
                          value={values.broadcastVia}
                        >
                          <Radio.Content className="t-flex !t-flex-row t-gap-x-2">
                            <Radio.Item
                              className="!t-w-[200px] t-text-body-sm"
                              align="start"
                              value="TEAM"
                            >
                              Team Inkle
                            </Radio.Item>
                            <Radio.Item value="user" className="t-text-body-sm">
                              {name}
                            </Radio.Item>
                          </Radio.Content>
                        </Radio.Root>
                      </div>
                    )}
                  </Modal.Body>
                  <Modal.FooterButtonGroup>
                    <Modal.RawClose asChild>
                      <Button>Cancel</Button>
                    </Modal.RawClose>
                    <Button
                      type="submit"
                      customType="primary"
                      onClick={broadcastCsv.open}
                      disabled={!isValid || !broadcastMediumSelected}
                    >
                      Next
                    </Button>
                  </Modal.FooterButtonGroup>
                  <BroadcastMessage {...broadcastCsv} close={handleClose} />
                </>
              );
            }}
          </FormikForm>
        </Modal.Content>
      </Modal.Root>
    </>
  );
};
